import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "itemKey", "isSelected", "onSelection", "rowComponent"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { FOCUSABLE_SELECTORS, KEYBOARD_KEYS } from "../../common/constants";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

function SelectableRow(props) {
  const {
    className,
    itemKey,
    isSelected,
    onSelection,
    rowComponent: RowComponent
  } = props,
        otherProps = _objectWithoutProperties(props, _excluded);
  /**
   * Determine if a row selection should be toggled.
   *
   * @param {Object} element Event target.
   */


  const rowIsSelected = element => {
    const tagName = element.tagName.toLowerCase();

    if (tagName === "tr") {
      return true;
    } else if (FOCUSABLE_SELECTORS.indexOf(tagName) !== -1) {
      // clicking on a button should not select the row
      return false;
    } else {
      // Recursively traveling up the DOM until it hits a `button`, input, or a `tr`
      return rowIsSelected(element.parentElement);
    }
  };
  /**
   * Using the `delete` statement below as opposed to destructuring the following properties
   * to avoid the scenario where 2 lint errors are thrown for each line: "no-unused-vars"
   * & "react/prop-types". The solution to this is either to add each property to PropTypes
   * validation (which would be misleading, as neither is ever used here), and then to
   * destructure from `props` combined with adding the "no-unused-vars" comment to each
   * line, OR to simply delete from otherProps, as seen below.
   */


  delete otherProps.itemIndex;

  if (RowComponent === "tr") {
    delete otherProps.columns;
    delete otherProps.item;
  }

  const updatedClassName = clsx(className, {
    "pnr-table__row--selected": isSelected
  });
  const {
    ENTER,
    SPACE
  } = KEYBOARD_KEYS;
  return _jsx(RowComponent, _objectSpread({
    "aria-selected": isSelected,
    className: updatedClassName,
    id: itemKey,
    onClick: e => {
      /* istanbul ignore else */
      if (rowIsSelected(e.target)) {
        onSelection(itemKey, !isSelected);
      }
    },
    onKeyDown: e => {
      const {
        key
      } = e;

      if (rowIsSelected(e.target) && (key === ENTER || key === SPACE)) {
        e.preventDefault();
        onSelection(itemKey, !isSelected);
      }
    }
  }, otherProps), itemKey);
}

SelectableRow.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Classes assigned to the row. */
  className: PropTypes.string,

  /** Boolean value that indicates if the row is selected. */
  isSelected: PropTypes.bool,

  /**
   * Item key value associated with the row. This maps directly to the Table property used
   * to uniquely identify each data object within the data set. Serves as the row's id.
   */
  itemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Callback handler which returns the necessary selection information to
   * `handleSelection` in the Selectable component.
   */
  onSelection: PropTypes.func,

  /**
   * Table's bodyRowComponent.  Used to decorate the current row
   * with Selectable Row attributes.
   */
  rowComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
} : {};
SelectableRow.defaultProps = {
  className: "",
  isSelected: false,
  itemKey: null,
  onSelection: null,
  rowComponent: null
};
export default SelectableRow;